import React, { useEffect, useState } from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import { getSignedFileUrl } from '../../services/api';
import { Avatar, useTheme } from '@mui/material';

const SecureAvatar = ({ src, alt, children, user, size, version = null, ...props }) => {
  // console.log("🚀 ~ SecureAvatar ~ src:", src)
  // if(!src)
  //   return null;
  // console.log("🚀 ~ SecureAvatar ~ src:", typeof src)
  const theme = useTheme();
  
  // Calculate font size based on avatar size
  const getFontSize = (avatarSize) => {
    if (typeof avatarSize !== 'number') return undefined;
    // Font size should be roughly 40% of avatar size
    return `${avatarSize * 0.4}px`;
  };
  
  //TODO cache results effciently
  // console.log("🚀 ~ SecureAvatar ~ logoKey:", src)
  
  // Extract the appropriate key based on version
  let fileKey = null;
  let isVersionedFile = false;
  
  if (src && typeof src === 'object') {
    // Check if we have versions and should use one
    if (version && src.versions && src.versions[version]) {
      fileKey = src.versions[version].key;
      isVersionedFile = true;
    } else if (src.key) {
      // Fall back to original key
      fileKey = src.key;
    } else if (src.url && src.url.includes('data:image')) {
      // Base64 support
      fileKey = src.url;
    }
  } else if (typeof src === 'string') {
    fileKey = src;
  }

  const [signedUrl, setSignedUrl] = useState(null);
  const isLocal = fileKey?.includes('blob') || fileKey?.includes('data:image');
  // console.log("🚀 ~ SecureAvatar ~ isLocal:", isLocal)
  // console.log("🚀 ~ SecureAvatar ~ fileKey:", fileKey)

  useEffect(() => {
    if (fileKey && !isLocal) {
      // Pass version parameter if using versioned file
      const urlPromise = version && isVersionedFile 
        ? getSignedFileUrl(fileKey, { version })
        : getSignedFileUrl(fileKey);
      
      urlPromise.then(setSignedUrl).catch(console.log);
    }
  }, [fileKey, isLocal, version, isVersionedFile]);

  // If user prop is provided, handle user-specific logic
  if (user && !src && !user.photo) {
    const initials = `${user.firstName?.charAt(0) || ''}${user.lastName?.charAt(0) || ''}`.toUpperCase();
    return (
      <Avatar
        {...props}
        sx={{
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText, // Ensure proper contrast
          ...(typeof size === 'number' && {
            width: size,
            height: size,
            fontSize: getFontSize(size)
          }),
          ...props.sx
        }}
      >
        {initials || children}
      </Avatar>
    );
  }

  return (
    <Avatar
      src={isLocal ? fileKey : signedUrl || undefined}
      alt={alt}
      {...props}
      sx={{
        ...((!fileKey && !signedUrl) && {
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText, // Ensure proper contrast
        }),
        ...(typeof size === 'number' && {
          width: size,
          height: size,
          fontSize: getFontSize(size)
        }),
        ...props.sx
      }}
    >
      {children}
    </Avatar>
  );
};

export default SecureAvatar;
